import { render } from "./RestaurantForm.vue?vue&type=template&id=05ec2c26&scoped=true"
import script from "./RestaurantForm.vue?vue&type=script&lang=js"
export * from "./RestaurantForm.vue?vue&type=script&lang=js"

import "./RestaurantForm.vue?vue&type=style&index=0&id=05ec2c26&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-05ec2c26"

export default script